import ProjectService from '../../../services/projects.service'
import PlaybooksService from '../../../services/playbooks.service'
import { Notification } from 'element-ui';
export default {
  loadCompleteProject({ state, commit }, payload) {
    commit('SET_LOADING', true)
    return ProjectService.getCompleteProject(payload.params, commit)
    .then(response => {
      commit('SET_PROJECTS', response[0])
      commit('SET_BOTS', response[1])
      //commit('SET_PLAYBOOKS', response[2])
      commit('SET_ADVANCED_SETTINGS', response[2])
      commit('SET_ACCOUNT_GROUPS', response[3])
      commit('SET_PROXIES_IDS', response[4])
      commit('SET_PROXIES_TAGS', response[5])
      commit('SET_LANGUAGES', response[6])
      commit('SET_POOLS', response[7])
      commit('SET_LOADING', false)
      commit('FULL_PROJECT_RELOADED', true);
    })
    .catch(error => commit('SET_ERROR', error.message))
    .finally(() => commit('SET_LOADING', false))
  },
  loadStats({state, commit}, payload) {
    
    return ProjectService.getByDatesAndProject(payload.params)
    .then(response => {
      commit('SET_STATS_BY_DATE', response.data);
    })
    .catch(error => commit('SET_ERROR', error.message))
    .finally(() => commit('SET_LOADING', false))
  },
  loadErrorTypes({state, commit}, payload) {
    var stat = [];
    commit('SET_STATS_BY_ERRORS', stat);

    return ProjectService.getByErrors(payload.params)
    .then(response => {
      
    })
    .catch(error => commit('SET_ERROR', error.message))
    .finally(() => commit('SET_LOADING', false))
  },
  loadReport ({ commit }, payload) {
    return ProjectService.loadReport(payload, commit)
      .then(response => {
        commit('SET_BOT_REPORT', { response: response, payload: payload })
        return response
      })
      .catch(error => {
        commit('SET_ERROR', error.message)
        throw error
      })
  },
  loadDayReport ({ commit }, payload) {
    return ProjectService.loadDayReport(payload, commit)
      .then(response => {
        commit('SET_BOT_REPORT', { response: response, payload: payload })
        return response
      })
      .catch(error => {
        commit('SET_ERROR', error.message)
        throw error
      })
  },
  loadBotReport({state, commit}, payload) {
    return ProjectService.loadReport(payload, commit)
    .then(response => {
      commit('SET_BOT_REPORT', {response:response, payload:payload})
    })
    .catch(error => commit('SET_ERROR', error.message))
  },
  createBot({ state, commit }, payload) {
    commit('SET_LOADING', true);    
    return ProjectService.createBot(payload)
    .then(response => {
      Notification.success({
        title: `Bot ${payload.params.name} has been created`,
        message: 'and saved to scheduler'
      });

      commit('ADD_BOT', response.data);
    })
    .catch(error => {
      //commit('SET_ERROR', error.message);
      /*Notification.error({
        title: 'Project "' + payload.data.name  + '" was not saved',
        message: error.message,
        duration: 0
      });*/
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
      }, 2000)
      
    })
  },
  createPlaybook({ state, commit }, payload) {
    commit('SET_LOADING', true);  
    return PlaybooksService.createPlaybook(payload)
    .then(response => {
      Notification.success({
        title: `Playbook has been created`,
        message: 'and saved to scheduler'
      });

      commit('CREATE_PLAYBOOK_RESPONSE_DATA', response.data);
    })
    .catch(error => {
      //commit('SET_ERROR', error.message);
      Notification.error({
        title: 'Playbook hasn\'t been created',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
      }, 1000)
      
    })
  },

  deletePlaybook({ state, commit }, payload) {
    commit('SET_LOADING', true);  
    return PlaybooksService.deletePlaybook(payload)
    .then(response => {
      Notification.success({
        title: `Playbook has been deleted`,
        message: ''
      });
        
      commit('DELETE_PLAYBOOK_RESPONSE_DATA', response.data);
    })
    .catch(error => {
      //commit('SET_ERROR', error.message);
      Notification.error({
        title: 'Playbook hasn\'t been deleted',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
      }, 1000)
      
    })
  },

  updatePlaybook({ state, commit }, payload) {
    commit('SET_LOADING', true);    
    return PlaybooksService.updatePlaybook(payload)
    .then(response => {
      Notification.success({
        title: `Playbook has been updated`,
        message: ''
      });
        
      commit('UPDATE_PLAYBOOK_RESPONSE_DATA', response.data);
    })
    .catch(error => {
      //commit('SET_ERROR', error.message);
      Notification.error({
        title: 'Playbook hasn\'t been updated',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
      }, 1000)
      
    })
  },

  getPlaybookSettings({ state, commit }, payload) {
    commit('SET_LOADING', true);
    commit('SET_PB_LOADING', true);
    return PlaybooksService.getAdvancedSettings(payload, commit)
    .then(response => {
      commit('SET_PLAYBOOK_ADVANCED', response)
      commit('SET_PB_LOADING', false);
      commit('UPDATE_BOT_STORE', response.data);  
    })
    .catch(error => commit('SET_ERROR', error.message))
    .finally(() => commit('SET_LOADING', false))
  },

  setPlaybookSettings({ state, commit }, payload) {
    commit('SET_LOADING', true)
    return PlaybooksService.setAdvancedSettings(payload, commit)
    .then(response => {
      commit('SET_PLAYBOOK_ADVANCED', response)
      commit('UPDATE_BOT_STORE', response.data);  
      commit('SET_LOADING', false)
    })
    .catch(error => commit('SET_ERROR', error.message))
    .finally(() => commit('SET_LOADING', false))
  },

  setDistributionAction({ state, commit }, payload) {
    commit('SET_LOADING', true)
    return PlaybooksService.setDistribution(payload, commit)
    .then(response => {
      commit('SET_LOADING', false)
      commit('DISTRIBUTION_SET', false)
    })
    .catch(error => commit('SET_ERROR', error.message))
    .finally(() => commit('SET_LOADING', false))
  },

  deletePlaybookSettings({ state, commit }, payload) {
    
    commit('SET_LOADING', true)
    return PlaybooksService.deleteAdvancedSettings(payload, commit)
    .then(response => {
      commit('DELETED_PLAYBOOK_ADVANCED',payload)
      commit('SET_LOADING', false)
    })
    .catch(error => commit('SET_ERROR', error.message))
    .finally(() => commit('SET_LOADING', false))
  },

  setProjectView({ state, commit }, payload) {  
    commit('SET_PROJECT_VIEW', payload);
  },
  updateBotData({state, commit}, payload) {
    commit('UPDATE_BOT_STORE', payload);
  },
  updateAdvanced({ state, commit }, payload) {
    commit('SET_LOADING', true);  
    return ProjectService.updateAdvanced(payload)
    .then(response => {
      Notification.success({
        title: `Advanced settings were updated`,
        message: ''
      });
        
      commit('UPDATE_ADVANCED', response.data);
    })
    .catch(error => {
      //commit('SET_ERROR', error.message);
      Notification.error({
        title: 'Failed to update advanced settings',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
      }, 1000)
      
    })
  },

  deleteBot({ state, commit }, payload) {
    commit('SET_LOADING', true);  
    return ProjectService.deleteBot(payload)
    .then(response => {
      Notification.success({
        title: `Bot has been deleted`,
        message: ''
      });
        
      commit('DELETED_BOT', response.data);
    })
    .catch(error => {
      Notification.error({
        title: 'Bot hasn\'t been deleted',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
      }, 1000)
      
    })
  },

  deleteProject({ state, commit }, payload) {
    commit('SET_LOADING', true);  
    return ProjectService.deleteProject(payload)
    .then(response => {
      Notification.success({
        title: `Project has been deleted`,
        message: ''
      });
        
      commit('DELETED_PROJECT', response.data);
    })
    .catch(error => {
      Notification.error({
        title: 'Project hasn\'t been deleted',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
      }, 1000)
      
    })
  },

  scheduleBotNow({ state, commit }, payload) {
    commit('SET_LOADING', true);  
    return ProjectService.runBot(payload)
    .then(response => {
      Notification.success({
        title: `Bot has been scheduled to be ran ASAP`,
        message: ''
      });
        
      commit('BOT_RAN_NOW', response.data);
    })
    .catch(error => {
      Notification.error({
        title: 'Bot hasn\'t been run',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
      }, 1000)
      
    })
  },

  startBot({ state, commit }, payload) {
    commit('SET_LOADING', true);  
    return ProjectService.startBot(payload)
    .then(response => {
      Notification.success({
        title: `Bot has been activated`,
        message: ''
      });
        
      commit('BOT_UPDATED', response.data);
    })
    .catch(error => {
      Notification.error({
        title: 'Bot hasn\'t been activated',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
      }, 1000)
      
    })
  },
  startBots({ state, commit }, payload) {
    commit('SET_LOADING', true);  
    return ProjectService.startAllBots(payload)
    .then(response => {
      Notification.success({
        title: `Bots have been activated`,
        message: ''
      });
        
      //commit('BOTS_UPDATED', response.data);
    })
    .catch(error => {
      Notification.error({
        title: 'Bots have not been activated',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
        commit('REFRESH_BOTS', payload);
      }, 50)
      
    })
  },

  stopBots({ state, commit }, payload) {
    commit('SET_LOADING', true);  
    return ProjectService.stopAllBots(payload)
    .then(response => {
      Notification.success({
        title: `Bots have been deactivated`,
        message: ''
      });
        
      //commit('BOTS_UPDATED', response.data);
    })
    .catch(error => {
      Notification.error({
        title: 'Bots have not been deactivated',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
        commit('REFRESH_BOTS', payload);
      }, 50)
      
    })
  },
  
  stopBot({ state, commit }, payload) {
    commit('SET_LOADING', true);  
    return ProjectService.stopBot(payload)
    .then(response => {
      Notification.success({
        title: `Bot has been deactivated`,
        message: ''
      });
      
      commit('BOT_UPDATED', response.data);
    })
    .catch(error => {
      Notification.error({
        title: 'Bot hasn\'t been deactivated',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => {
      setTimeout(function() {
        commit('SET_LOADING', false);
      }, 1000)
      
    })
  },

  activateProjectAction ({ state, commit }, payload) {
    commit('SET_LOADING', true);    
    return ProjectService.activateProject(payload)
    .then(response => {

      Notification.success({
        title: 'Project is turned on',
        message: 'saved to scheduler'
      });
      commit('SET_LOADING', false);
      commit('CHANGED_PROJECT_STATE', true);
    })
    .catch(error => {
      //commit('SET_ERROR', error.message);
      Notification.error({
        title: 'Project was not activated',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => commit('SET_LOADING', false))
  },
  deactivateProjectAction ({ state, commit }, payload) {
    commit('SET_LOADING', true);    
    return ProjectService.deactivateProject(payload)
    .then(response => {
      Notification.success({
        title: 'Project has been switched off',
        message: 'saved to scheduler'
      });
      commit('SET_LOADING', false);
      commit('CHANGED_PROJECT_STATE', false);
    })
    .catch(error => {
      //commit('SET_ERROR', error.message);
      Notification.error({
        title: 'Project was not deactivated',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => commit('SET_LOADING', false));
  },

  loadAllBotsByProject({ state, commit }, payload) {
    commit('SET_LOADING', true)
    return ProjectService.loadAllBotsByProject(payload, commit)
    .then(response => {
      commit('SET_BOTS', response);      
      commit('SET_LOADING', false);
    })
    .catch(error => commit('SET_ERROR', error.message))
    .finally(() => commit('SET_LOADING', false))
  },

  getAccountGroups({ state, commit }, payload) {
    commit('SET_LOADING', true);
    return ProjectService.getAccountGroups(payload, commit)
    .then(response => {
      commit('SET_ACCOUNT_GROUPS', response)
    })
    .catch(error => commit('SET_ERROR', error.message))
    .finally(() => commit('SET_LOADING', false))
  },

  copyProject({ state, commit }, payload) {
    commit('SET_LOADING', true)
    return ProjectService.copyProject(payload.model, commit)
    .then(response => {
      Notification.success({
        title: `Project has been copied`,
        message: ''
      });
      commit('SET_LOADING', false)
      commit('PROJECT_COPIED', response);
    })
    .catch(error => {
      Notification.error({
        title: 'Project hasn\'t been copied',
        message: error.message,
        duration: 0
      });
    })
    .finally(() => commit('SET_LOADING', false))
  },


 
}
